import React from 'react';
import { Button } from './Button';
export const ComparisonSection = () => {
  return <section className="bg-gradient-to-b from-teal-900 to-teal-800 text-white py-16" data-id="element-32">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-33">
        <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center" data-id="element-34">
          Neurotoned vs. Other Solutions
        </h2>
        <div className="overflow-x-auto mb-10" data-id="element-35">
          <table className="w-full mb-8" data-id="element-36">
            <thead data-id="element-37">
              <tr className="border-b-2 border-teal-400" data-id="element-38">
                <th className="p-4 text-left bg-teal-800/50" data-id="element-39"></th>
                <th className="p-4 text-left bg-teal-600/50 rounded-tl-lg" data-id="element-40">
                  Neurotoned
                </th>
                <th className="p-4 text-left bg-teal-800/30" data-id="element-41">
                  Jessica Maguire
                </th>
                <th className="p-4 text-left bg-teal-800/30" data-id="element-42">Irene Lyon</th>
                <th className="p-4 text-left bg-teal-800/30" data-id="element-43">Calm/Headspace</th>
                <th className="p-4 text-left bg-teal-800/30 rounded-tr-lg" data-id="element-44">
                  Apollo Neuro
                </th>
              </tr>
            </thead>
            <tbody data-id="element-45">
              <tr data-id="element-46">
                <td className="p-4 font-medium bg-teal-800/50" data-id="element-47">
                  Therapist-Created
                </td>
                <td className="p-4 bg-teal-600/50 text-teal-200" data-id="element-48">✓</td>
                <td className="p-4 bg-teal-800/30" data-id="element-49">✗</td>
                <td className="p-4 bg-teal-800/30" data-id="element-50">✓</td>
                <td className="p-4 bg-teal-800/30" data-id="element-51">✗</td>
                <td className="p-4 bg-teal-800/30" data-id="element-52">✗</td>
              </tr>
              <tr data-id="element-53">
                <td className="p-4 font-medium bg-teal-800/50" data-id="element-54">
                  Structured Daily Program
                </td>
                <td className="p-4 bg-teal-600/50 text-teal-200" data-id="element-55">✓</td>
                <td className="p-4 bg-teal-800/30" data-id="element-56">✗</td>
                <td className="p-4 bg-teal-800/30" data-id="element-57">✗</td>
                <td className="p-4 bg-teal-800/30" data-id="element-58">✓</td>
                <td className="p-4 bg-teal-800/30" data-id="element-59">✗</td>
              </tr>
              <tr data-id="element-60">
                <td className="p-4 font-medium bg-teal-800/50" data-id="element-61">
                  Focus on Freeze/Dissociation
                </td>
                <td className="p-4 bg-teal-600/50 text-teal-200" data-id="element-62">✓</td>
                <td className="p-4 bg-teal-800/30" data-id="element-63">✓</td>
                <td className="p-4 bg-teal-800/30" data-id="element-64">✗</td>
                <td className="p-4 bg-teal-800/30" data-id="element-65">✗</td>
                <td className="p-4 bg-teal-800/30" data-id="element-66">✗</td>
              </tr>
              <tr data-id="element-67">
                <td className="p-4 font-medium bg-teal-800/50" data-id="element-68">
                  Expressive + Somatic Tools
                </td>
                <td className="p-4 bg-teal-600/50 text-teal-200" data-id="element-69">✓</td>
                <td className="p-4 bg-teal-800/30" data-id="element-70">✗</td>
                <td className="p-4 bg-teal-800/30" data-id="element-71">✓</td>
                <td className="p-4 bg-teal-800/30" data-id="element-72">✗</td>
                <td className="p-4 bg-teal-800/30" data-id="element-73">✗</td>
              </tr>
              <tr data-id="element-74">
                <td className="p-4 font-medium bg-teal-800/50 rounded-bl-lg" data-id="element-75">
                  One-Time Payment
                </td>
                <td className="p-4 bg-teal-600/50 text-teal-200" data-id="element-76">✓</td>
                <td className="p-4 bg-teal-800/30" data-id="element-77">✗</td>
                <td className="p-4 bg-teal-800/30" data-id="element-78">✗</td>
                <td className="p-4 bg-teal-800/30" data-id="element-79">✗</td>
                <td className="p-4 bg-teal-800/30 rounded-br-lg" data-id="element-80">✗</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="text-center italic space-y-4 mb-8" data-id="element-81">
          <p data-id="element-82">You don't need another wearable.</p>
          <p data-id="element-83">You don't need more mindset coaching.</p>
          <p data-id="element-84">You need the body-based structure your system's been missing.</p>
        </div>
        <div className="flex justify-center" data-id="element-85">
          <Button link="https://www.neurotoned.com/offers/sPjut2p7/checkout?coupon_code=21OFFNEUROPROGRAMNEWMEMBERS" data-id="element-86">
            Reset Your Nervous System ➔
          </Button>
        </div>
      </div>
    </section>;
};